import "./About.css";
import CTA from "../../components/CTA/CTA";
import Footer from "../../components/Footer/Footer";
import Hero from "./Hero/Hero";
import Values from "./Values/Values";
import { Fade } from "react-reveal";
import Nero from "./Nero/Nero";

const About = () => {
  return (
    <Fade duration={0}>
      <div>
        <Nero />
        <Values />
        <Footer />
      </div>
    </Fade>
  );
};

export default About;
